//https://me-in-journey.com/entry/HTMLCSS-사이드바-메뉴-만들기-나타나는-2차-메뉴-만들기-feat-transform-translate#google_vignette
import styles from './Sidebar.module.css'
import { Link } from 'react-router-dom';
function Sidebar(){
    return(
        <>
            <aside className={styles.sideBar}>
                <section className={styles.sideBar__iconBox}>
                    <section className={styles.sideBar__icon1}>
                        <div></div>
                        <div></div>
                        <div></div>
                    </section>
                </section>
                <ul>
                    <li>
                        <Link to="/">Home</Link>
                    </li>
                    <li>
                        <Link to="/Profile">Profile</Link>
                    </li>
                    <li>
                        <Link to="/Contact">Contact</Link>
                    </li>
                    <li>
                        <Link to="/Publications">Publications</Link>
                    </li>
                    <li>
                        <Link to="/Education">Education</Link>
                    </li>
                    <li>
                        <Link to="/WorkExp">Work Experience</Link>
                    </li>
                    <li>
                        <Link to="/TeachingExp">Teaching Experience</Link>
                    </li>
                    <li>
                        <a href="https://github.com/azatos">Projects</a>
                        <ul>
                            <li><a href="https://github.com/azatos/azatos.github.io">Project 1</a></li>
                        </ul>
                    </li>
                </ul>
            </aside>
        </>
    );
}

export default Sidebar;